import { createContext, useContext } from 'react';
import type { NotificationInbox, NotificationItem } from '@/types';

export interface NotificationContextValue {
  inbox: NotificationInbox | null;
  isOpen: boolean;
  openInbox: () => void;
  closeInbox: () => void;
  markRead: (item: NotificationItem) => Promise<void>;
  markAllRead: () => Promise<void>;
}

/**
 * Lives in its own module so hot reloading the provider component never
 * recreates the context object that mounted consumers are subscribed to.
 */
export const NotificationContext = createContext<NotificationContextValue | null>(null);

export function useNotifications(): NotificationContextValue {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotifications must be used within a NotificationProvider.');
  }
  return context;
}
